import isElectron from './isElectron';

/**
 * True only while an in-flight library match request exists for this row.
 * Undefined `trackMatches[trackId]` means "not loaded or timed out", not loading.
 */
export function isTrackMatchesLoading(
  showMatcher: boolean,
  isLoading: boolean,
): boolean {
  return showMatcher && isElectron() && isLoading;
}
